import React, { useEffect, useRef, useState } from "react";
import "./Gaming.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Gaming = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];
  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Game Development",
      description:
        "End-to-end game development services from concept to launch and beyond",
      whatsappMessage:
        "Hello, I'm interested in Game Development consultation.",
    },
    {
      id: 2,
      title: "AR/VR Gaming",
      description:
        "Immersive augmented and virtual reality gaming experiences",
      whatsappMessage:
        "Hello, I'm interested in AR/VR Gaming consultation.",
    },
    {
      id: 3,
      title: "Mobile Gaming",
      description:
        "Engaging mobile games for iOS and Android platforms",
      whatsappMessage:
        "Hello, I'm interested in Mobile Gaming consultation.",
    },
    {
      id: 4,
      title: "Game Porting",
      description:
        "Porting games across different platforms and devices",
      whatsappMessage:
        "Hello, I'm interested in Game Porting consultation.",
    },
    {
      id: 5,
      title: "Multiplayer & Networking",
      description:
        "Robust multiplayer infrastructure and networking solutions",
      whatsappMessage:
        "Hello, I'm interested in Multiplayer & Networking consultation.",
    },
    {
      id: 6,
      title: "Game Testing & QA",
      description:
        "Comprehensive quality assurance and testing services for games",
      whatsappMessage:
        "Hello, I'm interested in Game Testing & QA consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="gaming-sector-page">
      <Helmet>
        <title>
          Gaming Technology Solutions | Game Development & Interactive Experiences
        </title>
        <meta
          name="description"
          content="Explore our comprehensive gaming technology solutions including game development, AR/VR experiences, mobile gaming, and multiplayer solutions."
        />
        <meta
          name="keywords"
          content="game development, gaming technology, AR/VR gaming, mobile games, game design, multiplayer gaming, game porting, gaming solutions"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="gaming-sector-hero">
        <div className="gaming-sector-hero-content">
          <h1 className="gaming-sector-hero-title">
            Level Up Your{" "}
            <span className="gaming-sector-highlight">
             Gaming Experience
            </span>
          </h1>
          <p className="gaming-sector-hero-description">
            We create immersive gaming experiences that captivate players, 
            push technological boundaries, and deliver unforgettable entertainment. 
            From mobile games to AAA titles, AR/VR experiences to multiplayer platforms.
          </p>
          <div className="gaming-sector-hero-buttons">
            <a href="/contact-us">
              <button className="gaming-sector-btn gaming-sector-btn-primary">
                Get Started
              </button>
            </a>
            <button className="gaming-sector-btn gaming-sector-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="gaming-sector-hero-visual">
          <div className="gaming-sector-animated-game">
            <div className="gaming-sector-game-controller"></div>
            <div className="gaming-sector-pixel-grid"></div>
            <div className="gaming-sector-game-icons">
              <div className="gaming-sector-character"></div>
              <div className="gaming-sector-power-up"></div>
            </div>
          </div>
          <div className="gaming-sector-orb gaming-sector-orb-1"></div>
          <div className="gaming-sector-orb gaming-sector-orb-2"></div>
          <div className="gaming-sector-orb gaming-sector-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="gaming-sector-services">
        <div className="gaming-sector-services-header">
          <h2 className="gaming-sector-section-title">
            Our Gaming Technology Solutions
          </h2>
          <p className="gaming-sector-section-subtitle">
            Innovative gaming technology services designed to create engaging experiences, 
            optimize performance, and deliver exceptional entertainment across all platforms.
          </p>
        </div>

        <div className="gaming-sector-services-grid">
          {/* Game Development Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-development"></div>
            </div>
            <h3>Game Development</h3>
            <p>
              End-to-end game development services from concept to launch and ongoing support.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Concept & Design</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Programming</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Art & Animation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Deployment</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">150+</div>
                <div className="stat-label">Games Developed</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">12+</div>
                <div className="stat-label">Platforms</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* AR/VR Gaming Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-vr"></div>
            </div>
            <h3>AR/VR Gaming</h3>
            <p>
              Immersive augmented and virtual reality gaming experiences that blur the line between real and virtual.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>VR Development</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>AR Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>3D Environments</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Motion Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40+</div>
                <div className="stat-label">AR/VR Projects</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">8</div>
                <div className="stat-label">Supported Headsets</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Mobile Gaming Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-mobile"></div>
            </div>
            <h3>Mobile Gaming</h3>
            <p>
              Engaging mobile games for iOS and Android with optimized performance and monetization strategies.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>iOS & Android</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Touch Controls</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Monetization</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Store Optimization</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">50M+</div>
                <div className="stat-label">Downloads</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">4.7/5</div>
                <div className="stat-label">Avg Rating</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Game Porting Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-porting"></div>
            </div>
            <h3>Game Porting</h3>
            <p>
              Expert game porting services across different platforms, consoles, and devices.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Cross-Platform</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Console Porting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Optimization</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Quality Assurance</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">12+</div>
                <div className="stat-label">Platforms</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Faster Porting</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Multiplayer Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-multiplayer"></div>
            </div>
            <h3>Multiplayer & Networking</h3>
            <p>
              Robust multiplayer infrastructure and networking solutions for seamless online gaming experiences.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Matchmaking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Server Architecture</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Anti-Cheat</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Live Ops</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Uptime</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">&lt;50ms</div>
                <div className="stat-label">Avg Latency</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Game Testing Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-testing"></div>
            </div>
            <h3>Game Testing & QA</h3>
            <p>
              Comprehensive quality assurance and testing services to ensure flawless gaming experiences.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Functionality Testing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Testing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compatibility Testing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>User Experience</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">98%</div>
                <div className="stat-label">Bugs Identified</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Testing</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Game Design Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-design"></div>
            </div>
            <h3>Game Design</h3>
            <p>
              Creative game design services including mechanics, storytelling, level design, and user experience.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Mechanics Design</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Level Design</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Narrative Design</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>UX/UI Design</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">200+</div>
                <div className="stat-label">Designs Created</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Client Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* LiveOps Card */}
          <div className="gaming-sector-service-card">
            <div className="gaming-sector-service-icon">
              <div className="gaming-sector-icon gaming-sector-icon-liveops"></div>
            </div>
            <h3>LiveOps & Maintenance</h3>
            <p>
              Ongoing game operations, updates, and maintenance services to keep games engaging and profitable.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Content Updates</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Event Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Community Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Monitoring</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Revenue Increase</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.5%</div>
                <div className="stat-label">Uptime</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="gaming-sector-services-cta">
          <h3>Ready to create your next gaming experience?</h3>
          <p>
            Schedule a free consultation with our gaming technology experts
            to discuss your project.
          </p>
          <div className="services-cta-buttons">
            <div className="gaming-sector-consultation-container">
              <button
                className="gaming-sector-primary-btn gaming-sector-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="gaming-sector-modal-overlay">
                  <div className="gaming-sector-modal-content">
                    <button
                      className="gaming-sector-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="gaming-sector-modal-title">
                      Gaming Technology Consultation
                    </h2>
                    <p className="gaming-sector-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="gaming-sector-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`gaming-sector-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="gaming-sector-option-title">
                            {option.title}
                          </h3>
                          <p className="gaming-sector-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`gaming-sector-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="gaming-sector-btn gaming-sector-btn-secondary">
              View Portfolio
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="gaming-sector-stats">
        <div className="gaming-sector-stats-container">
          <div className="gaming-sector-stat">
            <h3 className="gaming-sector-stat-number" data-count="250">
              250
            </h3>
            <p className="gaming-sector-stat-label">Games Developed</p>
          </div>
          <div className="gaming-sector-stat">
            <h3 className="gaming-sector-stat-number" data-count="50">
              50
            </h3>
            <p className="gaming-sector-stat-label">Million Downloads</p>
          </div>
          <div className="gaming-sector-stat">
            <h3 className="gaming-sector-stat-number" data-count="15">
              11
            </h3>
            <p className="gaming-sector-stat-label">Years Experience</p>
          </div>
          <div className="gaming-sector-stat">
            <h3 className="gaming-sector-stat-number" data-count="120">
              23
            </h3>
            <p className="gaming-sector-stat-label">Team Members</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="gaming-sector-cta">
        <div className="gaming-sector-cta-content">
          <h2>Ready to Create Your Next Gaming Experience?</h2>
          <p>
            Contact us today to discuss how our gaming technology expertise
            can bring your vision to life and create engaging player experiences.
          </p>
          <a href="/contact-us">
            <button className="gaming-sector-btn gaming-sector-btn-primary gaming-sector-btn-large">
              Start Your Project
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Gaming;